// extracted by mini-css-extract-plugin
export default {"settings_group_container":"TabBody_settings_group_container__m-hbq","group_title":"TabBody_group_title__3Vw3u","subtitle":"TabBody_subtitle__YfE6n"};